/**
 * `onCloseAutoFocus` handler for Radix menus: skips returning focus to the trigger when focus has already
 * moved outside the menu (e.g. the user clicked the search input while the menu was open), so it stays there.
 */
export const preventCloseAutoFocusIfFocusMovedOutside = (event: Event) => {
  const content = event.currentTarget;

  if (!(content instanceof HTMLElement)) {
    return;
  }

  const { activeElement, body } = content.ownerDocument;
  const hasFocusOutsideMenu = activeElement !== body && !content.contains(activeElement);

  if (hasFocusOutsideMenu) {
    event.preventDefault();
  }
};
